import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import EditFiles from "./library/EditFiles";
import PageHeader from "../../../components/PageHeader";

const LibraryPage = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [mode, setMode] = React.useState("list");

  const tabIndexValue = localStorage.getItem("libraryPage_TabIndex");
  const [tab, setTab] = React.useState(tabIndexValue || "files");

  if (mode === "list") {
    return (
      <>
        <PageHeader 
          title="Library" 
          subtitle="Access your training protocols, exercises, and content library"
        />
        <Box
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            px: { xs: 2, sm: 3 },
          }}
        >
          <Box sx={{ mt: 1, mb: 1 }}>
            <Tabs
              value={tab}
              onChange={(event, newValue) => {
                localStorage.setItem("libraryPage_TabIndex", newValue);
                setTab(newValue);
              }}
              aria-label="basic tabs example"
            >
              <Tab label="Files" value="files" />
              {/* <Tab label="Images" value="images" />
              <Tab label="Videos" value="videos" />
              <Tab label="Posts" value="posts" /> */}
            </Tabs>
          </Box>

          {tab === "files" && (
            <Box>
              <EditFiles />
            </Box>
          )}
        </Box>
      </>
    );
  } else if (mode === "details") {
    return (
      <Box
        sx={{
          marginTop: 1,
          display: "flex",
          flex: 1,
          flexDirection: "column",
          px: { xs: 2, sm: 3 },
        }}
      >
        <Box />
      </Box>
    );
  }
};

export default LibraryPage;
